import { useMediaQuery, getSectionBackgroundStyle } from 'academy-common-lib/utils/Styling';
import { H2 } from 'foundations-components/transitional/components/H2';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { View } from 'foundations-components/transitional/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BackgroundWrapper = styled.div.withConfig({
  displayName: "PublicPageAboutAcademySection__BackgroundWrapper",
  componentId: "sc-1ehhjkc-0"
})(["", ""], ({
  theme: trellisTheme
}) => getSectionBackgroundStyle(trellisTheme.color['do-not-use-gypsum']));
const GRID_ITEM_SIZE = {
  xs: 12,
  md: 4
};
const AboutGridItem = ({
  illustration,
  title,
  description,
  isTablet
}) => {
  const illustrationSize = isTablet ? 80 : 128;
  return /*#__PURE__*/_jsxs(View, {
    textAlign: "left",
    children: [/*#__PURE__*/_jsx(Illustration, {
      height: illustrationSize,
      loading: "lazy",
      marginBlockEnd: "600",
      name: illustration,
      width: illustrationSize
    }), /*#__PURE__*/_jsx(H3, {
      children: title
    }), description]
  });
};
const PublicPageAboutAcademySection = () => {
  const {
    isTablet
  } = useMediaQuery();
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(BackgroundWrapper, {
      children: /*#__PURE__*/_jsxs(View, {
        as: "section",
        paddingBlockEnd: "100",
        paddingBlockStart: "300",
        textAlign: isTablet ? 'center' : undefined,
        children: [/*#__PURE__*/_jsx(H2, {
          marginBlockEnd: "1000",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.whyLearnWithAcademy.title"
          })
        }), /*#__PURE__*/_jsxs(Grid, {
          marginBlockEnd: "500",
          children: [/*#__PURE__*/_jsx(GridItem, {
            marginBlockEnd: "600",
            size: GRID_ITEM_SIZE,
            children: /*#__PURE__*/_jsx(AboutGridItem, {
              description: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.whyLearnWithAcademy.free.description"
              }),
              illustration: 'unlock',
              isTablet: isTablet,
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.whyLearnWithAcademy.free.title"
              })
            })
          }), /*#__PURE__*/_jsx(GridItem, {
            marginBlockEnd: "600",
            size: GRID_ITEM_SIZE,
            children: /*#__PURE__*/_jsx(AboutGridItem, {
              description: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.whyLearnWithAcademy.personalised.description"
              }),
              illustration: 'dedicated-ip-board',
              isTablet: isTablet,
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.whyLearnWithAcademy.personalised.title"
              })
            })
          }), /*#__PURE__*/_jsx(GridItem, {
            size: GRID_ITEM_SIZE,
            children: /*#__PURE__*/_jsx(AboutGridItem, {
              description: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.whyLearnWithAcademy.global.description"
              }),
              illustration: 'additional-hubspot-account-globe',
              isTablet: isTablet,
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.whyLearnWithAcademy.global.title"
              })
            })
          })]
        })]
      })
    })
  );
};
export default PublicPageAboutAcademySection;